export const generativeAiBrandGuideline = "/generative_ai/brand_guideline";

/**
 * Guideline-id value meaning "create a new guideline": no persisted guideline exists yet, so the
 * get endpoint must not be called with it. Used as the :guidelineId route param on the studio.
 */
export const createGuidelineId = "create";
